module.exports = __webpack_public_path__ + "img/AF.10b8e746.svg";